'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAssignedResponderInWidget = undefined;

var _reselect = require('reselect');

var _findAssignedResponder = require('conversations-schema/thread/operators/findAssignedResponder');

var _getSelectedThread = require('../../selected-thread/selectors/getSelectedThread');

var _getAgentRespondersList = require('../../responders/selectors/getAgentRespondersList');

var _getWidgetBotResponder = require('../../selectors/widgetDataSelectors/getWidgetBotResponder');

var getAssignedResponderInWidget = exports.getAssignedResponderInWidget = (0, _reselect.createSelector)([_getAgentRespondersList.getAgentRespondersList, _getSelectedThread.getSelectedThread, _getWidgetBotResponder.getWidgetBotResponder], function (responders, selectedThread, botResponder) {
  return (0, _findAssignedResponder.findAssignedResponder)({
    thread: selectedThread,
    responders: responders,
    botResponder: botResponder
  });
});